import { createContext, useContext } from 'react';

/**
 * Provides the set of component IDs whose values were changed both locally
 * and remotely (conflict state). Used by EditFieldContainer to show a
 * yellow warning subfooter on conflicting fields.
 */
export const FieldConflictContext = createContext<string[]>([]);

export function useFieldConflictContext(): string[] {
  return useContext(FieldConflictContext);
}
